"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faEdit = require("@fortawesome/pro-regular-svg-icons/faEdit");

var _peractoUi = require("@peracto/peracto-ui");

var S = _interopRequireWildcard(require("./styled"));

var _excluded = ["values", "schema", "onSubmit", "onReset", "children", "infoPanel", "showActionPanel", "enableReinitialize", "checkbox"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Form = function Form(_ref) {
  var values = _ref.values,
      schema = _ref.schema,
      onSubmit = _ref.onSubmit,
      _ref$onReset = _ref.onReset,
      onReset = _ref$onReset === void 0 ? function () {} : _ref$onReset,
      children = _ref.children,
      _ref$infoPanel = _ref.infoPanel,
      infoPanel = _ref$infoPanel === void 0 ? false : _ref$infoPanel,
      _ref$showActionPanel = _ref.showActionPanel,
      showActionPanel = _ref$showActionPanel === void 0 ? true : _ref$showActionPanel,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? true : _ref$enableReinitiali,
      checkbox = _ref.checkbox,
      props = _objectWithoutProperties(_ref, _excluded);

  children = _react["default"].Children.toArray(children);
  /* let menu = children
      .filter(child => child.type.displayName === Group.displayName)
      .filter(group => group.props.predicate())
      .map((group, i) => <S.Item key={i} href={'#' + group.props.id}>{group.props.name}</S.Item>); */

  var initialValues = values;

  if (!!checkbox) {
    initialValues[checkbox.name] = (checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) || false;
  }

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: initialValues,
    validationSchema: schema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: onSubmit,
    onReset: onReset,
    enableReinitialize: enableReinitialize
  }, function (form) {
    if (Object.keys(form.errors).length > 0) {
      console.warn('Form Error:', form.errors);
    }

    return /*#__PURE__*/_react["default"].createElement(_formik.Form, props, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12"
    }, showActionPanel && /*#__PURE__*/_react["default"].createElement(_peractoUi.ActionPanel, {
      isVisible: form.dirty
    }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faEdit.faEdit,
      size: "lg",
      className: "mx-2"
    }), "You've made changes to this form."), /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn mr-2",
      "data-testid": "reset-form",
      onClick: form.handleReset
    }, "Reset"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "submit",
      className: "btn btn-success",
      "data-testid": "save-form",
      disabled: form.isSubmitting
    }, "Save"), !!checkbox && /*#__PURE__*/_react["default"].createElement(_peractoUi.Checkbox, {
      name: checkbox === null || checkbox === void 0 ? void 0 : checkbox.name,
      label: checkbox === null || checkbox === void 0 ? void 0 : checkbox.text,
      actionPanel: true
    }))), infoPanel && /*#__PURE__*/_react["default"].createElement(S.InfoPanel, null, infoPanel), children.map(function (group) {
      return group;
    }))));
  });
};

Form.displayName = 'Form';
Form.propTypes = {
  values: _propTypes["default"].object,
  schema: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node
};
Form.defaultProps = {
  values: {},
  children: []
};
var _default = Form;
exports["default"] = _default;